webpackJsonp([212197719340608],{

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _DocPage = __webpack_require__(20);
	
	var _DocPage2 = _interopRequireDefault(_DocPage);
	
	var _Anchor = __webpack_require__(41);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _CodeSample = __webpack_require__(5);
	
	var _CodeSample2 = _interopRequireDefault(_CodeSample);
	
	var _CodeBlock = __webpack_require__(21);
	
	var _CodeBlock2 = _interopRequireDefault(_CodeBlock);
	
	var _NextButton = __webpack_require__(62);
	
	var _NextButton2 = _interopRequireDefault(_NextButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _DocPage2.default,
	    { title: 'Styling' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'To style the component, use',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/gpbl/react-day-picker/blob/master/src/style.css' },
	        'src/style.css'
	      ),
	      ' ',
	      'as template and update it to fit the desired style. Then, just include it with your CSS files.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'The CSS classes follow a',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://css-tricks.com/bem-101/' },
	          'BEM-like syntax'
	        ),
	        '. If you need to customize the CSS class names, use the',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: '/api/DayPicker#classnames' },
	          _react2.default.createElement(
	            'code',
	            null,
	            'classNames'
	          )
	        ),
	        ' ',
	        'prop. Using this prop you can import a',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: '#css-modules' },
	          'CSS Module'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Importing the style template'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Import and extend the CSS template in your Sass files, for example from',
	      ' ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'node_modules'
	      ),
	      ':'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      { language: 'css' },
	      '@import "../node_modules/react-day-picker/lib/style"'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'or in your JS files (e.g. when using',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/webpack/css-loader' },
	        'webpack-css-loader'
	      ),
	      '):'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      'import "react-day-picker/lib/style.css";'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The stylesheet is also available from unpkg:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      { language: 'html' },
	      '<link rel="stylesheet" href="https://unpkg.com/react-day-picker/lib/style.css">'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Styling modifiers'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/docs/matching-days' },
	        'Modifiers'
	      ),
	      ' added to react-day-picker via the',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: '/api/DayPicker#modifiers' },
	        _react2.default.createElement(
	          'code',
	          null,
	          'modifiers'
	        )
	      ),
	      ' ',
	      'prop becomes CSS modifiers for the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'DayPicker-day'
	      ),
	      ' class. For example, if you use a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'firstOfMonth'
	      ),
	      ' modifier, the CSS class for the matched day cells will be ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'DayPicker-day--firstOfMonth'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Inline styles with modifiers'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Using the',
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/api/DayPicker#modifiersstyles' },
	        _react2.default.createElement(
	          'code',
	          null,
	          'modifiersStyles'
	        )
	      ),
	      ' ',
	      'prop, you can inline-style the cells for the specified modifiers:'
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'styling-inline' }),
	    _react2.default.createElement(
	      'h2',
	      { id: 'css-modules' },
	      'Styling with CSS Modules'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once you have setup your build system to import',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/css-modules/css-modules' },
	        'CSS Modules'
	      ),
	      ', use the',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: '/api/DayPicker#classnames' },
	        _react2.default.createElement(
	          'code',
	          null,
	          'classNames'
	        )
	      ),
	      ' ',
	      'prop to use the imported styles:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      'import React from \'react\';\nimport DayPicker from \'react-day-picker\';\n\nimport styles from \'../styles/cssmodules.css\';\n\nexport default function CSSModules() {\n  return <DayPicker classNames={ styles } />\n}'
	    ),
	    _react2.default.createElement(_Anchor2.default, { id: 'styling-css-modules' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Styling modifiers with CSS Modules'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Since you can\u2019t use the default\u2019s BEM-like modifiers CSS classes, you need to specify modifiers using the class names from the imported module:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      'import React from \'react\';\nimport DayPicker from \'react-day-picker\';\nimport styles from \'../styles/cssmodules.css\';\n\nexport default function CSSModules() {\n  return (\n    <DayPicker \n      classNames={ styles } \n      modifiers={{\n        [styles.birthday]: new Date(2018, 8, 19)\n      }}\n    />\n  );\n}'
	    ),
	    _react2.default.createElement(_NextButton2.default, { to: '/docs/localization', label: 'Localization' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-docs-styling-js-53f54ca40b32dbd9e102.js